<template>
  <div class="Inside_line_detail" :style="screenHeight">
    <div class="fixed_search" style="height: 100px">
      <div class="fixed_search_input">
        <Select v-model="formType" placeholder="请选择报表类型" title="报表类型">
          <Option v-for="(option, index) in formTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="date_selected fixed_search_input">
        <el-date-picker :clearable="false" v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" align="left" :default-time="['00:00:00', '23:59:59']"
                        :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareCallin"  clearable title="呼入量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="callinAnswer" placeholder="呼入量" title="呼入量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareCallout"  clearable title="呼出量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="calloutCount" placeholder="呼出量" title="呼出量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareConversionAgreeCount"  clearable title="转满意度量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="conversionAgreeCount" placeholder="转满意度量" title="转满意度量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareCallAverage"  clearable title="平均通话时长">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="callDurationAverage" placeholder="平均通话时长(秒)" title="平均通话时长(秒)"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareAverageQueuing" clearable title="平均排队时长">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="averageQueuingTime"  placeholder="平均排队时长(秒)"  title="平均排队时长(秒)"/>
      </div>

      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" style="margin-left: 10px" @click="exportExcel('8_3-1-1','统计报表=>通话总览=>导出')" v-if="roleList['8_3-1-1']">导出</Button>
      </div>

      <div class="fixed_operation_btn" style="margin-top:-3px">
        <Tooltip class="tips_font" placement="bottom">
                      <div slot="content">
                        <p>日期：统计的单位时间</p>
                          <p>呼入量：单位时间内所有客户呼入总数（仅外线呼入）</p>
                        <p> 转人工量：单位时间内进入技能组的通话数</p>
                          <p>转人工接通量：单位时间内客户与员工建立通话的总数（外线呼入+自动呼出）</p>
                          <p>转人工接通率：单位时间内客户与员工建立通话的总数（外线呼入+自动呼出）÷（单位时间内进入技能组的通话数)</p>
                          <p>呼出量：单位时间内所有呼出总数（手动呼出+自动呼出）</p>
                          <p>呼出接通量：单位时间内所有被接通的呼出总数（手动呼出+自动呼出）</p>
                          <p>呼出接通率：单位时间内所有被接通的呼出总数（手动呼出+自动呼出）÷单位时间内所有呼出总数（手动呼出+自动呼出）</p>
                        <p> 转满意度量：单位时间内通话转满意度总数</p>
                        <p> 好评率：客户评价非常满意和满意总数之和÷转满意度总数</p>
                          <p>平均通话时长：单位时间内客户与员工建立通话的总时长÷单位时间内通话数</p>
                          <p>平均排队时长：单位时间内员工接听时间和客户进技能组时间差值总和÷单位时间内客户与员工建立通话的总数（外线呼入+自动呼出）</p>
                      </div>
                    <img src="../../../assets/image/homeAsk.png"/>
        </Tooltip>
      </div>


    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe  ref="selection"  @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
  export default {
    name: "CallOverview",
    mixins:[publicFunClass,customerPublicBtn],
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        screenHeight:{height:''},
        tableHeight:600,
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        pageSize:20,
        speedChangePage: 1,
        spinShow:false,
        editable:false,
        tableClass: true,
        checkedAll:false,
        fieldList: [
          {type: 'selection', width: 50, fixed: true},{width: 150,key:'date','title':'日期', fixed: true},{width:120,key:'callinAnswer','title':'呼入量', fixed: true},
          {width:120,key:'turnPeople','title':'转人工量', fixed: true},{width:120,key:'turnPeopleAnswer','title':'转人工接通量'}, {key:'turnPeopleAverage',width:150,'title':'转人工接通率(%)'},
          {width:120,key:'calloutCount','title':'呼出量'},{key:'calloutAnswer',width: 120,'title':'呼出接通量'}, {key:'calloutAnswerAverage',width: 150,'title':'呼出接通率(%)'},
          {key:'turnSatisfied',width: 150,'title':'转满意度量'},{key:'praiseAverage',width:100,'title':'好评率(%)'},{key:'callDurationAverage',width: 150,'title':'平均通话时长'},{key:'lineUpAverage',width: 150,'title':'平均排队时长'}
        ],
        contentList: [],
        compareList:[{'id':'>','name':'大于'},{'id':'=','name':'等于'},{'id':'<','name':'小于'},{'id':'>=','name':'大于等于'},{'id':'<=','name':'小于等于'}],
        formTypeList:[{'id':'1','name':'时报'},{'id':'2','name':'日报'},{'id':'3','name':'周报'},{'id':'4','name':'月报'}],
        checkIds:[],
        formType:'2',
        starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
        conversionAgreeCount:'',
        compareConversionAgreeCount:'',
        compareCallin:'',
        callinAnswer:'',
        compareCallout:'',
        calloutCount:'',
        compareCallAverage:'',
        callDurationAverage:'',
        compareAverageQueuing:'',
        averageQueuingTime:'',
        journalType:"null",
        menuId:"null",
        queryParam: null,
      }
    },
    methods:{
      initSearch:function () {
        this.spinShow=true;
        this.$emit("closeVn",true);
        let that=this;
        let param={
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          date:this.starEndTime.length==0?"":this.starEndTime.toString(),
          formType:this.formType,
          conversionAgreeCount:this.conversionAgreeCount,
          compareConversionAgreeCount:this.compareConversionAgreeCount,
          compareCallin:this.compareCallin,
          callinAnswer:this.callinAnswer,
          compareCallout:this.compareCallout,
          calloutCount:this.calloutCount,
          compareCallAverage:this.compareCallAverage,
          callDurationAverage:this.callDurationAverage,
          compareAverageQueuing:this.compareAverageQueuing,
          averageQueuingTime:this.averageQueuingTime,
          journalType:"统计报表=>明细报表=>通话总览查询",
          menuId:"null"
        };
        // 导出时按照查询条件导出
        this.queryParam = param;
        this.$http.post("callAll/toIndex.json",param) .then(function (res) {
          let result=res.data;
          that.spinShow=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.checkIds=[];
          that.contentList=res.data.obj.list.content;
          that.total=res.data.obj.list.totalSize;
          let timeShowStyle=that.configInfo.timeShowStyle;
          if(timeShowStyle=='0'){
            for(let i=0;i< that.contentList.length;i++){
              that.contentList[i].callDurationAverage=that.contentList[i].callDurationAverageSecond;
              that.contentList[i].lineUpAverage=that.contentList[i].lineUpAverageSecond;
            }
          }
        })
      },
      reset:function(){
        this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
        this.formType="2";
        this.conversionAgreeCount="";
        this.compareConversionAgreeCount="";
        this.compareCallin="";
        this.callinAnswer="";
        this.compareCallout="";
        this.calloutCount="";
        this.compareCallAverage="";
        this.callDurationAverage="";
        this.compareAverageQueuing="";
        this.averageQueuingTime="";
      },
      closePublicPop:function (popSign) {
        if(!this.queryParam){
          this.$Modal.info({
              title:'提示',
              content:'请点击查询后再导出'
            });
          return false;
        }
        if(!this.contentList || this.contentList.length <= 0){
          this.$Modal.info({
              title:'提示',
              content:'当前无可导出的数据'
            });
          return false;
        }
        delete this.queryParam["pageNum"];
        delete this.queryParam["pageSize"];

        this.$set(this.queryParam, 'type', '1');
        this.$set(this.queryParam, 'journalType', this.journalType+"按搜索结果"+popSign);
        this.$set(this.queryParam, 'menuId', this.menuId);
        this.$Loading.start();
        this.operateExcelExport(this.queryParam,"callAll/exportIntercomCall.json");
      },
      //导出
      exportExcel:function (menuId,journalType) {
        this.journalType=journalType;
        this.menuId=menuId;
        //统计报表没有按选中结果导出
        this.closePublicPop('通话总览导出');
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-232;
    },
    destroyed(){
      this.$emit("closeVn",true);
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='8_3-1' && this.showPageCount==0){
          this.$emit("openVn", true);
          this.showPageCount++;
          this.handleScroll();
        }
      }
    }
  }
</script>

<style scoped>
  .el-table th.gutter{
   display: table-cell!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/CallStatistics/CallOverview.vue